import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const companyApi = createApi({
  reducerPath: "companyApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_BASE_URL, // e.g. http://localhost:4000/api
    credentials: "include",
  }),
  tagTypes: ["Company"],
  endpoints: (builder) => ({
    // CREATE: POST /api/companies
    addCompany: builder.mutation({
      query: (newCompany) => ({
        url: "/companies/create",
        method: "POST",
        body: newCompany,
      }),
      invalidatesTags: ["Company"],
    }),

    // LIST: GET /api/companies?page=&limit=&q=
    getAllCompanies: builder.query({
      query: ({ page = 1, limit = 10, search = "" } = {}) => ({
        url: "/companies",
        params: { page, limit, q: search },
      }),
      providesTags: ["Company"],
    }),

    // GET ONE: GET /api/companies/:id
    getCompanyById: builder.query({
      query: (id) => `/companies/${id}`,
      providesTags: (_res, _err, id) => [{ type: "Company", id }],
    }),

    // UPDATE: PUT /api/companies/:id
    updateCompany: builder.mutation({
      query: ({ id, ...patch }) => ({
        url: `/companies/${id}`,
        method: "PUT",
        body: patch,
      }),
      invalidatesTags: ["Company"],
    }),

    // DELETE: DELETE /api/companies/:id
    deleteCompany: builder.mutation({
      query: (id) => ({
        url: `/companies/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Company"],
    }),

    // (optional) ACTIVATE / DEACTIVATE
    activateCompany: builder.mutation({
      query: (id) => ({
        url: `/companies/${id}/activate`,
        method: "PATCH",
      }),
      invalidatesTags: ["Company"],
    }),
    deactivateCompany: builder.mutation({
      query: (id) => ({
        url: `/companies/${id}/deactivate`,
        method: "PATCH",
      }),
      invalidatesTags: ["Company"],
    }),
  }),
});

export const {
  useAddCompanyMutation,
  useGetAllCompaniesQuery,
  useGetCompanyByIdQuery,
  useUpdateCompanyMutation,
  useDeleteCompanyMutation,
  useActivateCompanyMutation,
  useDeactivateCompanyMutation,
} = companyApi;

export default companyApi;
